import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";

interface UserAvatarProps {
  name: string;
  src?: string;
  size?: "sm" | "md" | "lg";
}

export default function UserAvatar({ name, src, size = "md" }: UserAvatarProps) {
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .substring(0, 2);
  };
  
  const sizeClasses = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-12 w-12 text-base"
  };
  
  return (
    <Avatar className={sizeClasses[size]}>
      {src && <AvatarImage src={src} alt={name} />}
      <AvatarFallback className="bg-primary-100 text-primary-800">
        {src ? <User className="h-4 w-4" /> : getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
